import { render, staticRenderFns } from "./model.vue?vue&type=template&id=48cf174e"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports